import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
} from "common";
import I18n from "i18n-js";
import {
  getIntegrationHistoryService,
  IntegrationHistoryFormItem,
  IntegrationHistoryOptions,
} from "./integrationHistoryApi";

export interface UseIntegrationHistoryFormProps extends GridModalFormProps {}

export default function useIntegrationHistoryForm({
  id,
  afterSave,
}: UseIntegrationHistoryFormProps) {
  //const { integration_id } = useParams<"integration_id">();
  const service = getIntegrationHistoryService();

  const form = useForm<IntegrationHistoryFormItem, IntegrationHistoryOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "IntegrationHistory",
    afterSave,
    afterLoad: _newItem => {},
    onValidationFailed: () => {
      globalMessageHandler.error(I18n.t("App.formHasErrors"));
    },
    ...service,
  });

  return form;
}
